import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  &:hover > div {
    display: block;
  }
`;

const InfoWrapper = styled.div<any>`
  border-radius: 3px;
  padding: 5px;
  display: none;
  position: absolute;
  top: 125%;
  font-size: 1.5rem;

  left: 50%;
  transform: translateX(-50%);
  background-color: #777;
  color: #fff;
  z-index: 999;
`;

interface Props {
  children: React.ReactNode;
  info: string;
  bot?: boolean;
}

const HoverInfo: React.FC<Props> = ({
  children,
  info,
  bot,
}) => (
  <Wrapper>
    {children}
    <InfoWrapper>{info}</InfoWrapper>
  </Wrapper>
);

export default HoverInfo;
